/**
 * Download a URL without navigating away. An anchor click, because `window.open`
 * after an `await` is blocked as a popup. The URL must carry
 * `Content-Disposition: attachment` or the browser navigates instead.
 */
export function downloadUrl(url: string, filename?: string): void {
  const link = document.createElement("a");
  link.href = url;
  link.rel = "noopener noreferrer";
  if (filename) link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Download an in-memory blob, e.g. a CSV built from an API response.
 *
 * The object URL is revoked on the next tick rather than immediately: Safari
 * aborts the download if the URL dies in the same frame as the click.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  try {
    downloadUrl(url, filename);
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
}
